module.exports = __webpack_public_path__ + "static/img/item2.e7d95b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item2.jpg
// module id = TWNr
// module chunks = 0